'use client';

import { useSyncExternalStore } from 'react';

type Listener = () => void;

const ownerStates = new Map<symbol, boolean>();
const listeners = new Set<Listener>();
let isAnyCartDrawerOpen = false;

function updateSnapshot() {
  const nextSnapshot = [...ownerStates.values()].some(Boolean);
  if (nextSnapshot === isAnyCartDrawerOpen) {
    return;
  }

  isAnyCartDrawerOpen = nextSnapshot;
  listeners.forEach((listener) => listener());
}

export function setShortcodeCartDrawerState(owner: symbol, isOpen: boolean) {
  ownerStates.set(owner, isOpen);
  updateSnapshot();
}

export function removeShortcodeCartDrawerState(owner: symbol) {
  ownerStates.delete(owner);
  updateSnapshot();
}

export function useIsAnyShortcodeCartDrawerOpen() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => isAnyCartDrawerOpen,
    () => false,
  );
}
